// src/services/authApi.js
const BASE_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace('/api/shop', '/api/consumer')
  : '${process.env.REACT_APP_API_URL || "http://localhost:3000/api"}/consumer';

const TOKEN_KEY = 'jt_consumer_token';

export const authApi = {
  getToken:   () => localStorage.getItem(TOKEN_KEY),
  saveToken:  (token) => localStorage.setItem(TOKEN_KEY, token),
  clearToken: () => localStorage.removeItem(TOKEN_KEY),

  authHeaders: () => {
    const token = localStorage.getItem(TOKEN_KEY);
    return token ? { Authorization: `Bearer ${token}` } : {};
  },

  _fetch: async (path, options = {}) => {
    try {
      const res = await fetch(`${BASE_URL}${path}`, {
        headers: { 'Content-Type': 'application/json', ...options.headers },
        ...options,
      });
      return await res.json().catch(() => ({ success: false, message: 'Invalid response' }));
    } catch {
      return { success: false, message: 'Network error' };
    }
  },

  login: (email, password) =>
    authApi._fetch('/login', { method: 'POST', body: JSON.stringify({ email, password }) }),

  register: (data) =>
    authApi._fetch('/register', { method: 'POST', body: JSON.stringify(data) }),

  googleLogin: (credential) =>
    authApi._fetch('/google-login', { method: 'POST', body: JSON.stringify({ credential }) }),

  // FIX: was BASE_URL.replace('/auth/consumer', '/consumer') which did nothing
  // since BASE_URL no longer contains '/auth/consumer'
  getProfile: () =>
    fetch(`${BASE_URL}/profile`, {
      headers: { 'Content-Type': 'application/json', ...authApi.authHeaders() },
    }).then(r => r.json()).catch(() => ({ success: false })),

  getOrderHistory: (email, page = 1) =>
    fetch(`${BASE_URL.replace('/consumer', '/shop')}/orders/history?email=${encodeURIComponent(email)}&page=${page}`, {
      headers: { 'Content-Type': 'application/json' },
    }).then(r => r.json()).catch(() => ({ success: false })),

  logout: async () => {
    try { await authApi._fetch('/logout', { method: 'POST' }); } catch {}
    authApi.clearToken();
  },
};

export default authApi;
